<ng-container>
    <div style="margin-left: 78%; margin-top: 2%; margin-bottom: 2%;">
        <button class="noPrint same-btn mr-2" style="background-color: blue;color: white;"
            printSectionId="print-section" ngxPrint [useExistingCss]="true">Print</button>
        <button class="same-btn" mat-dialog-close onclick="closeexp()"
            style="background-color: red;color: white;">Close</button>
    </div>

    <div class="container" id="print-section">

        <div class="header-section">
            <div class="row heading-row"
                style="background-color: cadetblue; color: black;padding: 10px;margin-left: 4px;margin-right: 4px;">
                <div class="col-left">
                    <div><strong>दिनांक : {{ today | date:'dd-MM-yyyy' }}</strong> </div>
                    <div><strong>पृष्ठ क्र. : १</strong></div>
                </div>
                <div class="col-center">
                    <div><strong>हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - पॅकेज अहवाल</strong></div>
                    <div class="text-center"><strong>{{ packageName }}</strong></div>
                </div>
                <div class="col-right">
                    <div><strong>दिनांक पासून: {{ startDate | date:'dd-MM-yyyy' }}</strong></div>
                    <div><strong>दिनांक पर्यंत: {{ endDate | date:'dd-MM-yyyy' }}</strong></div>
                </div>
            </div>
        </div>

        <!-- Grouped Table Section -->
        <div *ngIf="groupedPackageData && (groupedPackageData | keyvalue).length > 0; else noPackages">
            <div *ngFor="let group of groupedPackageData | keyvalue">
                <h4 style="margin-top: 20px; color: darkblue;">{{ group.key }}</h4>
                <div class="table-responsive" style="margin-top: 10px;">
                    <table class="table table-bordered table-striped">
                        <thead style="background-color: lightgray;">
                            <tr>
                                <th>Sr No</th>
                                <th>Representative Name</th>
                                <th>Package Amount</th>
                                <th>Number of Packages</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of group.value; let i = index">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.rep_name }}</td>
                                <td>{{ item.total_pkg_amt | number:'1.2-2' }}</td>
                                <td>{{ item.no_of_packages }}</td>
                            </tr>
                            <!-- Total Row -->
                            <tr style="font-weight: bold;">
                                <td colspan="2">Total</td>
                                <td>
                                    {{ getGroupTotalAmount(group.value) | number:'1.2-2' }}
                                </td>
                                <td>
                                    {{ getGroupTotalPackages(group.value) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <ng-template #noPackages>
            <div class="text-center">
                <p style="margin-top: 225px ;color:red; font-weight: bold;font-size: 25px !important;">No Packages
                    Found.</p>
            </div>
        </ng-template>

    </div>
</ng-container>